import styled from "styled-components";

const Background = styled.div`
  position: absolute;
  height: 183px;
  width: 100%;
  left: 0;
  top: 0;
  border-bottom: solid 1px #f0f3f8;
  background: #ffffff;
`;

export default Background;
